// Function => Toggle class "active" on an element

export default function toggleActiveClass(...array) {
    for(let i = 0; i < array.length; i++){
        array[i].classList.toggle('active');
    }
}   
